import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $commissions,
  $totalCountOfCommissions,
  $total,
  getCommissions,
  commissionsMounted,
  totalMounted,
} from './model'
import { CommissionsRequest } from './types'

export const useCommissions = (strategyId: number) => {
  React.useEffect(() => {
    commissionsMounted({
      strategyId: strategyId,
      limit: 10,
      page: 1,
      orderBy: 'paidAt',
      orderDirection: '-',
      searchText: {},
    })
  }, [])

  const onChangeCommissionsList = ({
    strategyId,
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: CommissionsRequest) => {
    commissionsMounted({
      strategyId,
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }
  React.useEffect(() => {
    totalMounted({
      strategyId: strategyId,
      limit: 10,
      page: 1,
      orderBy: 'paidAt',
      orderDirection: '-',
      searchText: {},
    })
  }, [])

  const onChangeTotalList = ({
    strategyId,
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: CommissionsRequest) => {
    totalMounted({
      strategyId,
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  const loading = useStore(getCommissions.pending)

  const commissions = useStore($commissions)
  const total = useStore($total)
  const totalCountOfCommissions = useStore($totalCountOfCommissions)
  return {
    commissions,
    total,
    totalCountOfCommissions,
    loading,
    onChangeCommissionsList,
    onChangeTotalList,
  }
}
